export default "__VITE_PUBLIC_ASSET__bc98e02f__"